export const noop = () => {
  // noop
};

export const isClient = typeof window !== 'undefined';
